// extracted by mini-css-extract-plugin
module.exports = {"root":"SendTestEmailModal_root__2Zg_w","paper":"SendTestEmailModal_paper__31BWb"};